/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownSecurityQuestion } from '../models/db_DropdownSecurityQuestion';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SecurityQuestions {
    /**
     * Get a list of security questions
     * @returns db_DropdownSecurityQuestion OK
     * @throws ApiError
     */
    public static listSecurityQuestions(): CancelablePromise<Array<db_DropdownSecurityQuestion>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/security-questions',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
